import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import UserMultiSelect from "../../../../forms/Dropdowns/UserMultiSelect";
import UserTable from "../../../../layout/BasicUserTable";

const UserSection = ({
  selectedUsers,
  setSelectedUsers,
  setUnsavedChanges,
}) => {
  return (
    <Box sx={{maxWidth: "100%", overflow: "hidden" }}>
      <Typography variant="h4">Assign Users</Typography>
      <Box
        sx={{
          mt: 1,
          overflowY: "scroll !important"
        }}
      >
        <UserMultiSelect setSelectedUsers={setSelectedUsers} />
        <UserTable users={selectedUsers} setUsers={setSelectedUsers} height={"25vh"}/>
      </Box>
    </Box>
  );
};

export default UserSection;
